<template>
  <div class="user-option-main">
    <Menus icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-admin-settings-male-64.png" :menu="menu" />
    <div class="right-container" style="overflow: auto">
      <!-- Landing Page -->
      <div class="option-section">
        <div class="title">My Landing Page</div>
        <div class="option-body">
          <div :style="{ textDecoration: newLandingPage ? 'line-through' : 'none' }">
            {{ currentUserOptions.LandingPage ? currentUserOptions.LandingPage : 'Default Landing Page' }}
          </div>
          <div v-if="newLandingPage">{{ newLandingPage }}</div>
          <button @click="showSelection = true">Change Landing Page</button>
          <div v-if="successChangedLandingPage" class="success-changed"> Successfully changed your landing page </div>
          <div v-if="errorChangeLandingPage" class="error-changed"> An error occurred, please try again </div>
        </div>
        <div v-if="newLandingPage" class="cancel-save-container">
          <button @click="newLandingPage = ''">
            <img class="save-cancel-img" src="https://img.icons8.com/ultraviolet/40/000000/cancel.png" />
            Cancel
          </button>
          <button @click="saveLandingPage">
            <img class="save-cancel-img" src="https://img.icons8.com/officel/16/000000/checked.png" />
            Save
          </button>
        </div>
      </div>
      <!-- Job Order Page -->
      <div class="option-section">
        <div class="title">Preferred Job Order</div>
        <div class="option-body">
          <Dropdown
            :items="jobOrderItem"
            itemKey="item"
            placeholder="[TMS] Job Order"
            :selectedObject.sync="selectedJobOrder"
            :isRequired="true"
            style="min-width: fit-content; max-width: 50%"
          />
        </div>
        <div class="cancel-save-container">
          <button @click="saveJobOrder">
            <img class="save-cancel-img" src="https://img.icons8.com/officel/16/000000/checked.png" />
            Save
          </button>
          <div v-if="successChangedJobOrder" class="success-changed"> Successfully updated preferred job order </div>
          <div v-if="errorChangedJobOrder" class="error-changed"> An error occurred, please try again </div>
        </div>
      </div>
      <!-- Background color -->
      <div class="option-section">
        <div class="title">Background Color</div>
        <div class="option-body">
          <div
            :style="{
              textDecoration:
                (
                  newBackgroundColor.replace('#', '') !=
                  (currentUserOptions.BackgroundColor ? currentUserOptions.BackgroundColor.replace('#', '') : 'E0ECF8')
                ) ?
                  'line-through'
                : 'none',
            }"
          >
            #{{ currentUserOptions.BackgroundColor ? currentUserOptions.BackgroundColor.replace('#', '') : 'E0ECF8' }}
          </div>
          <div
            v-if="
              newBackgroundColor.replace('#', '') !=
              (currentUserOptions.BackgroundColor ? currentUserOptions.BackgroundColor.replace('#', '') : 'E0ECF8')
            "
          >
            #{{ newBackgroundColor.replace('#', '') }}
          </div>
          <div class="change-color-button">
            <button @click="changeColorClicked">Change Color</button>
            <button v-if="resetColorButton" class="reset-color-button" @click="resetColor"> Reset to Default </button>
            <input type="color" v-model="newBackgroundColor" ref="colorInput" @blur="colorBlur" />
          </div>
          <div v-if="successChangedBackgroundColor" class="success-changed">
            Successfully changed your background color
          </div>
          <div v-if="errorChangeBackgroundColor" class="error-changed"> An error occurred, please try again </div>
        </div>
        <div
          v-if="
            newBackgroundColor.replace('#', '') !=
            (currentUserOptions.BackgroundColor ? currentUserOptions.BackgroundColor.replace('#', '') : 'E0ECF8')
          "
          class="cancel-save-container"
        >
          <button
            @click="
              newBackgroundColor = `#${currentUserOptions.BackgroundColor ? currentUserOptions.BackgroundColor : 'E0ECF8'}`
            "
          >
            <img class="save-cancel-img" src="https://img.icons8.com/ultraviolet/40/000000/cancel.png" />
            Cancel
          </button>
          <button @click="saveNewBackgroundColor">
            <img class="save-cancel-img" src="https://img.icons8.com/officel/16/000000/checked.png" />
            Save
          </button>
        </div>
      </div>
      <!-- Set Preferred Date Format -->
      <div class="option-section">
        <div class="title">Preferred Date Format</div>
        <div class="option-body">
          <Dropdown
            :items="dateFormats"
            itemKey="format"
            placeholder="Date Format"
            :selectedObject.sync="selectedDateFormat"
            :isRequired="true"
            style="width: 15%"
          />
        </div>
        <div class="cancel-save-container">
          <button @click="saveDateFormat">
            <img class="save-cancel-img" src="https://img.icons8.com/officel/16/000000/checked.png" />
            Save
          </button>
          <div v-if="successChangedDateFormat" class="success-changed">
            Successfully updated preferred date format
          </div>
          <div v-if="errorChangedDateFormat" class="error-changed"> An error occurred, please try again </div>
        </div>
      </div>
      <!-- Set Preferred Currency Format -->
      <div class="option-section">
        <div class="title">Preferred Currency Format</div>
        <div class="option-body">
          <Dropdown
            :items="digitGroupingFormats"
            itemKey="format"
            placeholder="Digit Grouping Symbol"
            :selectedObject.sync="selectedCurrencyDigitGrouping"
            :isRequired="true"
            style="width: 15%"
            :errorMessage.sync="selectedCurrencyDigitGroupingError"
          />
          <Dropdown
            :items="decimalSymbolFormats"
            itemKey="format"
            placeholder="Decimal Symbol"
            :selectedObject.sync="selectedCurrencyDecimalSymbol"
            :isRequired="true"
            style="width: 15%"
            :errorMessage.sync="selectedCurrencyDecimalSymbolError"
          />
          <Dropdown
            :items="decimalPlaceFormats"
            itemKey="format"
            placeholder="No. of digits after decimal"
            :selectedObject.sync="selectedCurrencyDecimalPlaceFormat"
            :isRequired="true"
            style="width: 15%"
            :isDisabled="true"
          />
        </div>
        <div class="cancel-save-container">
          <button @click="saveCurrencyFormat">
            <img class="save-cancel-img" src="https://img.icons8.com/officel/16/000000/checked.png" />
            Save
          </button>
          <div v-if="successChangeCurrencyFormat" class="success-changed">
            Successfully updated preferred currency format
          </div>
          <div v-if="errorChangeCurrencyFormat" class="error-changed"> An error occurred, please try again </div>
        </div>
      </div>
      <!-- Set Preferred Weight Format -->
      <div class="option-section">
        <div class="title">Preferred Weight Format</div>
        <div class="option-body">
          <Dropdown
            :items="digitGroupingFormats"
            itemKey="format"
            placeholder="Digit Grouping Symbol"
            :selectedObject.sync="selectedWeightDigitGrouping"
            :isRequired="true"
            style="width: 15%"
            :errorMessage.sync="selectedWeightDigitGroupingError"
          />
          <Dropdown
            :items="decimalSymbolFormats"
            itemKey="format"
            placeholder="Decimal Symbol"
            :selectedObject.sync="selectedWeightDecimalSymbol"
            :isRequired="true"
            style="width: 15%"
            :errorMessage.sync="selectedWeightDecimalSymbolError"
          />
          <Dropdown
            :items="decimalPlaceFormats"
            itemKey="format"
            placeholder="No. of digits after decimal"
            :selectedObject.sync="selectedWeightDecimalPlaceFormat"
            :isRequired="true"
            style="width: 15%"
            :isDisabled="true"
          />
        </div>
        <div class="cancel-save-container">
          <button @click="saveWeightFormat">
            <img class="save-cancel-img" src="https://img.icons8.com/officel/16/000000/checked.png" />
            Save
          </button>
          <div v-if="successChangeWeightFormat" class="success-changed">
            Successfully updated preferred Weight format
          </div>
          <div v-if="errorChangeWeightFormat" class="error-changed"> An error occurred, please try again </div>
        </div>
      </div>
      <!-- Set Preferred Volume Format -->
      <div class="option-section">
        <div class="title">Preferred Volume Format</div>
        <div class="option-body">
          <Dropdown
            :items="digitGroupingFormats"
            itemKey="format"
            placeholder="Digit Grouping Symbol"
            :selectedObject.sync="selectedVolumeDigitGrouping"
            :isRequired="true"
            style="width: 15%"
            :errorMessage.sync="selectedVolumeDigitGroupingError"
          />
          <Dropdown
            :items="decimalSymbolFormats"
            itemKey="format"
            placeholder="Decimal Symbol"
            :selectedObject.sync="selectedVolumeDecimalSymbol"
            :isRequired="true"
            style="width: 15%"
            :errorMessage.sync="selectedVolumeDecimalSymbolError"
          />
          <Dropdown
            :items="decimalPlaceFormats"
            itemKey="format"
            placeholder="No. of digits after decimal"
            :selectedObject.sync="selectedVolumeDecimalPlaceFormat"
            :isRequired="true"
            style="width: 15%"
            :isDisabled="true"
          />
        </div>
        <div class="cancel-save-container">
          <button @click="saveVolumeFormat">
            <img class="save-cancel-img" src="https://img.icons8.com/officel/16/000000/checked.png" />
            Save
          </button>
          <div v-if="successChangeVolumeFormat" class="success-changed">
            Successfully updated preferred Volume format
          </div>
          <div v-if="errorChangeVolumeFormat" class="error-changed"> An error occurred, please try again </div>
        </div>
      </div>
      <!-- Add Signature Section -->
      <div class="option-section">
        <div class="title">Signature</div>
        <div class="signature-section">
          <div class="signature">
            Signature 1
            <div v-if="savedSignature1" class="signature-border">
              <img :src="savedSignature1" class="signature-preview" />
            </div>
            <div v-else-if="Signature1" class="signature-border">
              <img :src="Signature1" v-show="showPreview" class="signature-preview" />
            </div>
            <div v-else class="signature-upload">
              <div class="upload-desc">Drag or Click to Upload</div>
              <input
                type="file"
                id="imageSignature1"
                ref="imageSignature1"
                accept="image/*"
                @change="handleFileUpload1"
              />
            </div>
          </div>
          <div class="signature">
            Signature 2
            <div v-if="savedSignature2" class="signature-border">
              <img :src="savedSignature2" class="signature-preview" />
            </div>
            <div v-else-if="Signature2" class="signature-border">
              <img :src="Signature2" v-show="showPreview2" class="signature-preview" />
            </div>
            <div v-else class="signature-upload">
              <div class="upload-desc">Drag or Click to Upload</div>
              <input
                type="file"
                id="imageSignature2"
                ref="imageSignature2"
                accept="image/*"
                @change="handleFileUpload2"
              />
            </div>
          </div>
          <div class="signature">
            Signature 3
            <div v-if="savedSignature3" class="signature-border">
              <img :src="savedSignature3" class="signature-preview" />
            </div>
            <div v-else-if="Signature3" class="signature-border">
              <img :src="Signature3" v-show="showPreview3" class="signature-preview" />
            </div>
            <div v-else class="signature-upload">
              <div class="upload-desc">Drag or Click to Upload</div>
              <input
                type="file"
                id="imageSignature3"
                ref="imageSignature3"
                accept="image/*"
                @change="handleFileUpload3"
              />
            </div>
          </div>
        </div>
        <!-- Save Signature and Reset Signature Buttons-->
        <button @click="submitSignature">
          <img class="save-cancel-img" src="https://img.icons8.com/officel/16/000000/checked.png" />
          Save
        </button>
        <span
          v-if="
            imageSignature1 != null ||
            imageSignature2 != null ||
            imageSignature3 != null ||
            savedSignature1 ||
            savedSignature2 ||
            savedSignature3
          "
        >
          <button @click="clearSignature" style="margin-left: 10px">
            <img class="save-cancel-img" src="https://img.icons8.com/ultraviolet/40/000000/cancel.png" width="16px;" />
            Reset
          </button>
          <span v-if="successSaveSignature" class="success-changed"> Successfully saved your signature </span>
          <span v-if="errorSaveSignature" class="error-changed"> An error occurred, please try again </span>
        </span>
      </div>
      <!-- Set Default Signature Section -->
      <div class="option-section">
        <div class="title">Default Signature</div>
        <div class="signature-section">
          <div class="default-signature-section">
            <div class="default-signature-1">Choose Default Signature</div>
            <div class="default-signature">
              Signature 1<button class="default-select-button" @click="defaultSignatureSelect(1)">Select</button>
            </div>
            <div class="default-signature">
              Signature 2<button class="default-select-button" @click="defaultSignatureSelect(2)">Select</button>
            </div>
            <div class="default-signature">
              Signature 3<button class="default-select-button" @click="defaultSignatureSelect(3)">Select</button>
            </div>
          </div>
          <div class="default-signature-preview">
            Selected Default Signature
            <div v-if="currentUserOptions.setDefaultSignature == 'Signature1'"> Signature 1 </div>
            <div v-else-if="currentUserOptions.setDefaultSignature == 'Signature2'"> Signature 2 </div>
            <div v-else-if="currentUserOptions.setDefaultSignature == 'Signature3'"> Signature 3 </div>
            <div v-else> No default signature </div>
            <div v-if="currentUserOptions[currentUserOptions.setDefaultSignature]">
              <img
                :src="currentUserOptions[currentUserOptions.setDefaultSignature]"
                class="signature-preview signature-border"
              />
            </div>
            <div v-else class="signature-preview signature-border" style="min-height: 200px; text-align: center"
              >No signature found</div
            >
          </div>
        </div>
        <button @click="submitDefaultSignature">
          <img class="save-cancel-img" src="https://img.icons8.com/officel/16/000000/checked.png" />
          Save
        </button>
        <button
          v-if="currentUserOptions[currentUserOptions.setDefaultSignature] || currentUserOptions.setDefaultSignature"
          @click="resetDefaultSignature"
          style="margin-left: 10px"
        >
          <img class="save-cancel-img" src="https://img.icons8.com/ultraviolet/16/000000/cancel.png" />
          Reset
        </button>
        <span v-if="successSaveDefaultSignature" class="success-changed">
          Successfully saved your default signature
        </span>
        <span v-if="errorSaveDefaultSignature" class="error-changed"> An error occurred, please try again </span>
      </div>
    </div>
    <div v-if="showSelection" class="pages-selection">
      <div class="popup-title">Select your landing page</div>
      <div class="popup-container">
        <div class="modules" v-for="(p, pi) in pagesList" :key="pi">
          <div v-if="p.enabled && Object.keys(p.items).length > 0">
            {{ p.title }}
          </div>
          <div v-if="p.enabled && Object.keys(p.items).length > 0">
            <div v-for="(i, index) in p.items" :key="index">
              <div v-if="Array.isArray(i)">
                <div class="sub-modules">{{ index }}</div>
                <div v-for="(a, ai) in i" :key="ai" class="pages" @click="selectedLandingPage(a.title, a.route)">
                  {{ a.title }}
                </div>
              </div>
              <div v-else-if="i.visible" class="pages" @click="selectedLandingPage(i.title, i.route)">
                {{ i.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-section">
        <button class="btn-alert" @click="showSelection = false">Cancel</button>
        <button v-if="currentUserOptions.LandingPage" @click="resetToDefault"> Reset to default </button>
      </div>
    </div>
    <Loader :isVisible.sync="loading" :loadingText="loadText" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      loadText: '',

      menu: [
        {
          title: 'My Preference',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-admin-settings-male-64.png',
        },
      ],
      newLandingPage: '',
      successChangedLandingPage: false,
      errorChangeLandingPage: false,
      defaultBackgroundColor: 'E0ECF8',
      successChangedBackgroundColor: false,
      errorChangeBackgroundColor: false,
      successSaveSignature: false,
      errorSaveSignature: false,
      successSaveDefaultSignature: false,
      errorSaveDefaultSignature: false,

      selectedJobOrder: null,
      jobOrderItem: [
        {
          '#': '0',
          item: 'By Job (Descending)',
        },
        {
          '#': '1',
          item: 'By Job Datetime (Descending)',
        },
      ],
      successChangedJobOrder: false,
      errorChangedJobOrder: false,

      newRoute: '',

      showSelection: false,
      pagesList: [],

      newBackgroundColor: '',
      resetColorButton: false,

      dateFormats: [
        { format: 'dd-MM-yyyy' },
        { format: 'MM-dd-yyyy' },
        { format: 'yyyy-MM-dd' },
        { format: 'dd/MM/yyyy' }
      ],
      selectedDateFormat: null,
      successChangedDateFormat: false,
      errorChangedDateFormat: false,

      //selections for all format selections, decouple if needed
      digitGroupingFormats: [{ format: ',' }, { format: '.' }, { format: "'" }],

      decimalSymbolFormats: [{ format: '.' }, { format: ',' }, { format: "'" }],
      decimalPlaceFormats: [
        { format: '0' },
        { format: '1' },
        { format: '2' },
        { format: '3' },
        { format: '4' },
        { format: '5' },
        { format: '6' },
        { format: '7' },
        { format: '8' },
        { format: '9' },
        { format: '10' },
      ],

      //currency format
      selectedCurrencyDigitGrouping: null,
      selectedCurrencyDecimalSymbol: null,
      selectedCurrencyDecimalPlaceFormat: null,
      successChangeCurrencyFormat: false,
      errorChangeCurrencyFormat: false,
      selectedCurrencyDigitGroupingError: '',
      selectedCurrencyDecimalSymbolError: '',

      //weight format
      selectedWeightDigitGrouping: null,
      selectedWeightDecimalSymbol: null,
      selectedWeightDecimalPlaceFormat: null,
      successChangeWeightFormat: false,
      errorChangeWeightFormat: false,
      selectedWeightDigitGroupingError: '',
      selectedWeightDecimalSymbolError: '',

      //volume format
      selectedVolumeDigitGrouping: null,
      selectedVolumeDecimalSymbol: null,
      selectedVolumeDecimalPlaceFormat: null,
      successChangeVolumeFormat: false,
      errorChangeVolumeFormat: false,
      selectedVolumeDigitGroupingError: '',
      selectedVolumeDecimalSymbolError: '',

      filled1: false,
      filled2: false,
      filled3: false,

      imageSignature1: '',
      imageSignature2: '',
      imageSignature3: '',
      Signature1: '',
      Signature2: '',
      Signature3: '',
      savedSignature1: '',
      savedSignature2: '',
      savedSignature3: '',

      showPreview: false,
      showPreview2: false,
      showPreview3: false,

      currentUserOptions: {
        LandingPage: '',
        TMS_JobOrderList: '',
        BackgroundColor: '',
        PreferredDateFormat: '',
        Signature1: '',
        Signature2: '',
        Signature3: '',
        setDefaultSignature: '',
      },
    };
  },
  components: {},
  props: {},
  methods: {
    selectedLandingPage: function (page, route) {
      if (page == this.currentUserOptions.LandingPage) {
        this.showSelection = false;
        return;
      }
      this.newRoute = route;
      this.newLandingPage = page;
      this.showSelection = false;
    },
    saveJobOrder: async function () {
      const oldJobOrder = this.currentUserOptions.TMS_JobOrderList;
      this.currentUserOptions.TMS_JobOrderList = this.selectedJobOrder['#'];
      const result = await this.saveUserOptions('Saving Job Order');

      if (result) {
        // successful update
        this.$store.commit('updatePreferredJobOrder', this.currentUserOptions.TMS_JobOrderList);
        this.successChangedJobOrder = true;
        setTimeout(() => {
          this.successChangedJobOrder = false;
        }, 2500);
      } else {
        // error during update
        this.errorChangedJobOrder = true;
        this.selectedJobOrder = oldJobOrder ? oldJobOrder : '0';
        this.currentUserOptions.TMS_JobOrderList = oldJobOrder ? oldJobOrder : '0';
        setTimeout(() => {
          this.errorChangedJobOrder = false;
        }, 2500);
      }
    },
    saveUserOptions: async function (loading) {
      this.loadText = loading;
      this.loading = true;
      const postData = {
        item: 'UserOptions',
        value: this.currentUserOptions,
      };

      const save = await this.$apiCallV2(`/UserOptions/SaveSettingsSystemUser`, postData);
      this.loading = false;
      return save[0].Results == 0;
    },
    saveLandingPage: async function () {
      const oldLandingPage = this.currentUserOptions.LandingPage;
      this.currentUserOptions.LandingPage = this.newRoute;
      const result = await this.saveUserOptions('Saving Landing Page');

      if (result) {
        this.successChangedLandingPage = true;
        this.currentUserOptions.LandingPage = this.newLandingPage;
        this.newLandingPage = '';
        const loginDetails = await this.$apiCallV2('/Login/GetDetails');
        loginDetails.LandingPage = this.newRoute;
        this.$apiCallV2('/Login/UpdateLoginDetails', loginDetails);
      } else {
        this.errorChangeLandingPage = true;
        this.newLandingPage = '';
        this.currentUserOptions.LandingPage = oldLandingPage ? oldLandingPage : '';
        setTimeout(() => {
          this.errorChangeLandingPage = false;
        }, 2500);
      }
    },
    resetToDefault: function () {
      if (!this.currentUserOptions.LandingPage) {
        this.showSelection = false;
      } else {
        this.newLandingPage = 'Default Landing Page';
        this.newRoute = '';
        this.showSelection = false;
      }
    },
    // Background color methods
    changeColorClicked: function () {
      this.$refs.colorInput.click();
      this.$refs.colorInput.focus();
      this.resetColorButton = true;
    },
    colorBlur: function () {
      setTimeout(() => {
        this.resetColorButton = false;
      }, 100);
    },
    saveNewBackgroundColor: async function () {
      const oldColor = this.currentUserOptions.BackgroundColor;
      this.currentUserOptions.BackgroundColor = this.newBackgroundColor.replace('#', '');
      const result = await this.saveUserOptions('Saving Background Color');

      if (result) {
        this.successChangedBackgroundColor = true;
        setTimeout(() => {
          this.successChangedBackgroundColor = false;
        }, 2500);
        this.$store.commit('updateBackgroundColor',  this.currentUserOptions.BackgroundColor);
      } else {
        this.errorChangeBackgroundColor = true;
        this.newBackgroundColor = `#${oldColor ? oldColor : 'E0ECF8'}`;
        this.currentUserOptions.BackgroundColor = oldColor ? oldColor : 'E0ECF8';
        setTimeout(() => {
          this.errorChangeBackgroundColor = false;
        }, 2500);
      }
    },
    resetColor: function () {
      this.newBackgroundColor = `#${this.defaultBackgroundColor}`;
    },
    saveDateFormat: async function () {
      const oldDateFormat = this.currentUserOptions.PreferredDateFormat;
      this.currentUserOptions.PreferredDateFormat = this.selectedDateFormat.format;
      const result = await this.saveUserOptions('Saving Date Format');

      if (result) {
        // successful update
        this.$store.commit('updatePreferredDateFormat', this.currentUserOptions.PreferredDateFormat);
        this.successChangedDateFormat = true;
        setTimeout(() => {
          this.successChangedDateFormat = false;
        }, 2500);
      } else {
        // error during update
        this.errorChangedDateFormat = true;
        this.selectedDateFormat = { format: oldDateFormat ? oldDateFormat : 'dd-MM-yyyy' };
        this.currentUserOptions.PreferredDateFormat = oldDateFormat ? oldDateFormat : 'dd-MM-yyyy';
        setTimeout(() => {
          this.errorChangedDateFormat = false;
        }, 2500);
      }
    },
    saveCurrencyFormat: async function () {
      this.successChangeCurrencyFormat = false;
      this.errorChangeCurrencyFormat = false;

      let checkFields = true;
      if (!this.selectedCurrencyDigitGrouping) {
        checkFields = false;
        this.selectedCurrencyDigitGroupingError = 'Currency Digit Grouping Symbol is Required!';
      }
      if (!this.selectedCurrencyDecimalSymbol) {
        checkFields = false;
        this.selectedCurrencyDecimalSymbolError = 'Currency Decimal Symbol is Required!';
      }

      if (!checkFields) {
        this.errorChangeCurrencyFormat = true;
        setTimeout(() => {
          this.errorChangeCurrencyFormat = false;
        }, 2500);
        return;
      }

      // Join the formatting into a string
      this.currentUserOptions.PreferredCurrencyFormat =
        this.selectedCurrencyDigitGrouping.format + this.selectedCurrencyDecimalSymbol.format;
      const result = await this.saveUserOptions('Saving Currency Format');

      if (result) {
        // successful update
        // Commit the changes to stored state
        this.$store.commit('updateCurrencyFormat', this.currentUserOptions.PreferredCurrencyFormat);
        this.successChangeCurrencyFormat = true;
        setTimeout(() => {
          this.successChangeCurrencyFormat = false;
        }, 2500);
      } else {
        // error during update
        this.errorChangeCurrencyFormat = true;

        const defaultCurrencyFormat = this.$store.state.currencyFormat;
        const getCurrencyFormat = this.currentUserOptions.PreferredCurrencyFormat;

        this.selectedCurrencyDigitGrouping = {
          format: getCurrencyFormat?.[0] ? getCurrencyFormat[0] : defaultCurrencyFormat[0],
        };
        this.selectedCurrencyDecimalSymbol = {
          format: getCurrencyFormat?.[1] ? getCurrencyFormat[1] : defaultCurrencyFormat[1],
        };
        this.currentUserOptions.PreferredCurrencyFormat = getCurrencyFormat ? getCurrencyFormat : defaultCurrencyFormat;

        setTimeout(() => {
          this.errorChangeCurrencyFormat = false;
        }, 2500);
      }
    },
    saveWeightFormat: async function () {
      this.successChangeWeightFormat = false;
      this.errorChangeWeightFormat = false;

      let checkFields = true;
      if (!this.selectedWeightDigitGrouping) {
        checkFields = false;
        this.selectedWeightDigitGroupingError = 'Weight Digit Grouping Symbol is Required!';
      }
      if (!this.selectedWeightDecimalSymbol) {
        checkFields = false;
        this.selectedWeightDecimalSymbolError = 'Weight Decimal Symbol is Required!';
      }

      if (!checkFields) {
        this.errorChangeWeightFormat = true;
        setTimeout(() => {
          this.errorChangeWeightFormat = false;
        }, 2500);
        return;
      }

      // Join the formatting into a string
      this.currentUserOptions.PreferredWeightFormat =
        this.selectedWeightDigitGrouping.format + this.selectedWeightDecimalSymbol.format;
      const result = await this.saveUserOptions('Saving Weight Format');

      if (result) {
        // successful update
        // Commit the changes to stored state
        this.$store.commit('updateWeightFormat', this.currentUserOptions.PreferredWeightFormat);
        this.successChangeWeightFormat = true;
        setTimeout(() => {
          this.successChangeWeightFormat = false;
        }, 2500);
      } else {
        // error during update
        this.errorChangeWeightFormat = true;

        const defaultWeightFormat = this.$store.state.weightFormat;
        const getWeightFormat = this.currentUserOptions.PreferredWeightFormat;

        this.selectedWeightDigitGrouping = {
          format: getWeightFormat?.[0] ? getWeightFormat[0] : defaultWeightFormat[0],
        };
        this.selectedWeightDecimalSymbol = {
          format: getWeightFormat?.[1] ? getWeightFormat[1] : defaultWeightFormat[1],
        };
        this.currentUserOptions.PreferredWeightFormat = getWeightFormat ? getWeightFormat : defaultWeightFormat;

        setTimeout(() => {
          this.errorChangeWeightFormat = false;
        }, 2500);
      }
    },
    saveVolumeFormat: async function () {
      this.successChangeVolumeFormat = false;
      this.errorChangeVolumeFormat = false;

      let checkFields = true;
      if (!this.selectedVolumeDigitGrouping) {
        checkFields = false;
        this.selectedVolumeDigitGroupingError = 'Volume Digit Grouping Symbol is Required!';
      }
      if (!this.selectedVolumeDecimalSymbol) {
        checkFields = false;
        this.selectedVolumeDecimalSymbolError = 'Volume Decimal Symbol is Required!';
      }

      if (!checkFields) {
        this.errorChangeVolumeFormat = true;
        setTimeout(() => {
          this.errorChangeVolumeFormat = false;
        }, 2500);
        return;
      }

      // Join the formatting into a string
      this.currentUserOptions.PreferredVolumeFormat =
        this.selectedVolumeDigitGrouping.format + this.selectedVolumeDecimalSymbol.format;
      const result = await this.saveUserOptions('Saving Volume Format');

      if (result) {
        // successful update
        // Commit the changes to stored state
        this.$store.commit('updateVolumeFormat', this.currentUserOptions.PreferredVolumeFormat);
        this.successChangeVolumeFormat = true;
        setTimeout(() => {
          this.successChangeVolumeFormat = false;
        }, 2500);
      } else {
        // error during update
        this.errorChangeVolumeFormat = true;

        const defaultVolumeFormat = this.$store.state.VolumeFormat;
        const getVolumeFormat = this.currentUserOptions.PreferredVolumeFormat;

        this.selectedVolumeDigitGrouping = {
          format: getVolumeFormat?.[0] ? getVolumeFormat[0] : defaultVolumeFormat[0],
        };
        this.selectedVolumeDecimalSymbol = {
          format: getVolumeFormat?.[1] ? getVolumeFormat[1] : defaultVolumeFormat[1],
        };
        this.currentUserOptions.PreferredVolumeFormat = getVolumeFormat ? getVolumeFormat : defaultVolumeFormat;

        setTimeout(() => {
          this.errorChangeVolumeFormat = false;
        }, 2500);
      }
    },

    handleFileUpload1: function () {
      // this.filled1 = false;
      // this.filled2 = true;
      // this.filled3 = true;
      this.imageSignature1 = this.$refs.imageSignature1.files[0];
      // console.log("New image added:", this.imageSignature1);
      const reader = new FileReader();
      reader.readAsDataURL(this.imageSignature1);
      reader.onload = () => {
        this.Signature1 = reader.result.split(',')[1];
      };
      reader.addEventListener(
        'load',
        function () {
          this.showPreview = true;
          this.Signature1 = reader.result;
        }.bind(this),
        false,
      );
    },
    handleFileUpload2: function () {
      // this.filled2 = false;
      // this.filled1 = true;
      // this.filled3 = true;
      this.imageSignature2 = this.$refs.imageSignature2.files[0];
      // console.log("New image added:", this.imageSignature2);
      const reader2 = new FileReader();
      reader2.readAsDataURL(this.imageSignature2);
      reader2.onload = () => {
        this.Signature2 = reader2.result.split(',')[1];
      };
      reader2.addEventListener(
        'load',
        function () {
          this.showPreview2 = true;
          this.Signature2 = reader2.result;
        }.bind(this),
        false,
      );
    },
    handleFileUpload3: function () {
      // this.filled3 = false;
      // this.filled1 = true;
      // this.filled2 = true;
      this.imageSignature3 = this.$refs.imageSignature3.files[0];
      // console.log("New image added:", this.imageSignature3);
      // console.log(this.$refs.imageSignature3.files[0]);
      // console.log(this.$refs.imageSignature3.files[1]);
      // console.log(this.$refs.imageSignature3.files[2]);
      const reader3 = new FileReader();
      reader3.readAsDataURL(this.imageSignature3);
      reader3.onload = () => {
        this.Signature3 = reader3.result.split(',')[1];
      };
      reader3.addEventListener(
        'load',
        function () {
          this.showPreview3 = true;
          this.Signature3 = reader3.result;
        }.bind(this),
        false,
      );
    },
    submitSignature: async function () {
      //console.log(this.imageSignature1);

      if (
        (this.imageSignature1 == '' || this.imageSignature1 == null) &&
        (this.imageSignature2 == '' || this.imageSignature2 == null) &&
        (this.imageSignature3 == '' || this.imageSignature3 == null)
      ) {
        this.$showAlert('error', 'No Customer Uploaded', 'Please upload your signatures');
      } else {
        const loginDetails = await this.$apiCallV2('/Login/GetDetails');
        const formData = new FormData();
        formData.append('file', this.imageSignature1);
        formData.append('file', this.imageSignature2);
        formData.append('file', this.imageSignature3);
        formData.append('folder', loginDetails.ConfigCode + ',useroptions');
        formData.append('filePrefix', loginDetails.ConfigCode + '_' + loginDetails.LoginUserID + '_');
        const SignatureLink = await this.$apiCallV2('/Upload/UploadFile', formData);
        // let resultLinks = SignatureLink['data'].split('\n'); // to get the links

        const resultLinks = SignatureLink['Files'];

        if (resultLinks != undefined) {
          for (let i = 0; i < resultLinks.length; i++) {
            if (this.imageSignature1 != null && !this.filled1) {
              this.currentUserOptions.Signature1 = resultLinks[i];
              this.filled1 = true;
              // console.log(this.filled1);
              // console.log('test' + this.filled2);
              // console.log('test2' + this.filled3);
            } else if (this.imageSignature2 != null && !this.filled2) {
              this.currentUserOptions.Signature2 = resultLinks[i];
              this.filled2 = true;
              // console.log(this.filled2);
              // console.log('test3' + this.filled1);
              // console.log('test4' + this.filled3);
            } else if (this.imageSignature3 != null && !this.filled3) {
              this.currentUserOptions.Signature3 = resultLinks[i];
              this.filled3 = true;
              // console.log(this.filled3);
              // console.log('test5' + this.filled1);
              // console.log('test6' + this.filled2);
            }
          }
        }

        const result = await this.saveUserOptions('Saving Signature');
        if (result) {
          this.successSaveSignature = true;
          setTimeout(() => {
            this.successSaveSignature = false;
          }, 2500);
          // console.log('saved success');
        } else {
          this.errorSaveSignature = true;
          setTimeout(() => {
            this.errorSaveSignature = false;
          }, 2500);
        }
      }
      /* !! using base64 !! 
      this.currentUserOptions.Signature1 = this.Signature1;
      this.currentUserOptions.Signature2 = this.Signature2;
      this.currentUserOptions.Signature3 = this.Signature3;
      var result = await this.saveUserOptions("Saving Signature");
      if (result) {
        console.log("Success Uploading Signature");
      } else {
        console.log("Error Uploading Signature");
      } */
    },
    clearSignature: function () {
      this.imageSignature1 = null;
      this.imageSignature2 = null;
      this.imageSignature3 = null;
      this.Signature1 = '';
      this.Signature2 = '';
      this.Signature3 = '';
      this.savedSignature1 = '';
      this.savedSignature2 = '';
      this.savedSignature3 = '';
      this.currentUserOptions.Signature1 = '';
      this.currentUserOptions.Signature2 = '';
      this.currentUserOptions.Signature3 = '';
      this.filled1 = false;
      this.filled2 = false;
      this.filled3 = false;
    },
    defaultSignatureSelect: function (signatureNum) {
      if (signatureNum == 1) {
        this.currentUserOptions.setDefaultSignature = 'Signature1';
      } else if (signatureNum == 2) {
        this.currentUserOptions.setDefaultSignature = 'Signature2';
      } else {
        this.currentUserOptions.setDefaultSignature = 'Signature3';
      }
    },
    submitDefaultSignature: async function () {
      // console.log(this.currentUserOptions[this.currentUserOptions.setDefaultSignature]);
      // console.log(this.savedSignature1);
      // console.log("log");
      // console.log(this.currentUserOptions.setDefaultSignature);

      if (
        this.currentUserOptions[this.currentUserOptions.setDefaultSignature] == null ||
        this.currentUserOptions[this.currentUserOptions.setDefaultSignature] == ''
      ) {
        this.$showAlert('error', 'No Signature Found', 'Please select a default signature');
      } else {
        const result = await this.saveUserOptions('Saving Signature');
        // console.log(result);
        if (result) {
          this.successSaveDefaultSignature = true;
          setTimeout(() => {
            this.successSaveDefaultSignature = false;
          }, 2500);
        } else {
          this.errorSaveDefaultSignature = true;
          setTimeout(() => {
            this.errorSaveDefaultSignature = false;
          }, 2500);
        }
      }
    },
    resetDefaultSignature: function () {
      this.currentUserOptions.setDefaultSignature = '';
    },
  },

  async mounted() {
    this.loadText = 'Getting Landing Page';
    this.loading = true;

    const userOptionsData = await this.$apiCallV2('/UserOptions/GetSettingsSystemUser?settings=UserOptions');

    if (userOptionsData[0].SettingsValue) {
      const userOptionsObj = JSON.parse(userOptionsData[0].SettingsValue);
      const page = userOptionsObj.LandingPage.split('/');
      this.currentUserOptions.LandingPage = page[page.length - 1];
      this.currentUserOptions.BackgroundColor =
        userOptionsObj.BackgroundColor ? userOptionsObj.BackgroundColor : 'E0ECF8';

      this.currentUserOptions.TMS_JobOrderList =
        userOptionsObj.TMS_JobOrderList ? userOptionsObj.TMS_JobOrderList : null;
      this.selectedJobOrder =
        !userOptionsObj.TMS_JobOrderList ? null : (
          this.jobOrderItem.find((item) => {
            return item['#'] == userOptionsObj.TMS_JobOrderList;
          })
        );

      this.currentUserOptions.PreferredDateFormat =
        userOptionsObj.PreferredDateFormat ? userOptionsObj.PreferredDateFormat : 'dd-MM-yyyy';
      this.selectedDateFormat = { format: this.currentUserOptions.PreferredDateFormat };

      const currencyFormat = this.$store.state.currencyFormat;
      this.selectedCurrencyDigitGrouping = { format: currencyFormat[0] };
      this.selectedCurrencyDecimalSymbol = { format: currencyFormat[1] };

      const weightFormat = this.$store.state.weightFormat;
      this.selectedWeightDigitGrouping = { format: weightFormat[0] };
      this.selectedWeightDecimalSymbol = { format: weightFormat[1] };

      const volumeFormat = this.$store.state.volumeFormat;
      this.selectedVolumeDigitGrouping = { format: volumeFormat[0] };
      this.selectedVolumeDecimalSymbol = { format: volumeFormat[1] };

      //Dont need to get from current state as getUserOption is already ran whenever the app is loaded. Just get from state

      this.currentUserOptions.Signature1 = userOptionsObj.Signature1 ? userOptionsObj.Signature1 : '';
      this.savedSignature1 = userOptionsObj.Signature1;
      if ((this.savedSignature1 = userOptionsObj.Signature1)) {
        this.filled1 = true;
        // console.log(this.filled1);
      }

      this.currentUserOptions.Signature2 = userOptionsObj.Signature2 ? userOptionsObj.Signature2 : '';
      this.savedSignature2 = userOptionsObj.Signature2;
      if ((this.savedSignature2 = userOptionsObj.Signature2)) {
        this.filled2 = true;
        // console.log(this.filled2);
      }

      this.currentUserOptions.Signature3 = userOptionsObj.Signature3 ? userOptionsObj.Signature3 : '';
      this.savedSignature3 = userOptionsObj.Signature3;
      if ((this.savedSignature3 = userOptionsObj.Signature3)) {
        this.filled3 = true;
        // console.log(this.filled3);
      }

      this.currentUserOptions.setDefaultSignature = userOptionsObj.setDefaultSignature;
    }

    //will set regardless because userOptions might not exist
    this.selectedCurrencyDecimalPlaceFormat = { format: this.$store.state.currencyFormat.substring(2) };
    this.selectedWeightDecimalPlaceFormat = { format: this.$store.state.weightFormat.substring(2) };
    this.selectedVolumeDecimalPlaceFormat = { format: this.$store.state.volumeFormat.substring(2) };

    this.newBackgroundColor = `#${
      this.currentUserOptions?.BackgroundColor ? this.currentUserOptions.BackgroundColor : 'E0ECF8'
    }`;

    this.loading = false;
    this.pagesList = this.$subMenu.getSASMenus();
  },
  watch: {
    showSelection: function (val) {
      if (val && this.pagesList.length == 0) {
        this.pagesList = this.$subMenu.getSASMenus();
      }
    },
    successChangedLandingPage: function (val) {
      if (val) {
        setTimeout(() => {
          this.successChangedLandingPage = false;
        }, 2500);
      }
    },
    newBackgroundColor: function (val) {
      this.$bus.$emit('backgroundColorChanged', val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.user-option-main {
  width: 100%;
  height: 100%;
  display: flex;
  // background-color: yellow;
  padding: 5px 45px;
  font-size: 12px;
  > .right-container {
    width: 100%;
    overflow: hidden;
    height: 100%;
    margin-left: 5px;
    > .option-section {
      padding: 5px;
      background-color: white;
      border-radius: 5px;
      margin-bottom: 5px;
      > .title {
        font-weight: bold;
      }
      > .option-body {
        display: flex;
        align-items: center;
        margin: 5px 0;
        > * {
          margin-right: 5px;
        }
        > .change-color-button {
          position: relative;
          > input {
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            z-index: -1;
          }
          > .reset-color-button {
            position: absolute;
            left: calc(100% + 5px);
            width: 160px;
          }
        }
      }
      > .cancel-save-container {
        display: flex;
        > button {
          margin-right: 5px;
          > img {
            height: 17px;
          }
        }
      }
    }
  }
  > .pages-selection {
    position: fixed;
    width: 100%;
    height: 100%;
    padding-top: 50px;
    top: 0;
    left: 0;
    background-color: rgba(200, 200, 200, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 9999999;
    > .popup-container {
      background-color: white;
      width: 100%;
      max-width: 300px;
      height: 70%;
      position: relative;
      padding: 10px;
      border-radius: 3px;
      overflow: auto;
    }
    > .popup-title {
      width: 100%;
      max-width: 300px;
      background-color: white;
      padding: 5px 0;
      text-align: center;
      font-weight: bold;
    }
    > .button-section {
      background-color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      max-width: 300px;
      padding: 5px 0;
      > button {
        margin: 3px 5px;
      }
    }
  }
}
.pages {
  margin-left: 20px;
  text-decoration: underline;
  cursor: pointer;
}
.sub-modules {
  margin-left: 10px;
}
.signature {
  padding-bottom: 10px;
  margin-left: 10px;
}
.signature-section {
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.default-signature-section {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.default-signature {
  padding-bottom: 3px;
  margin-left: 10px;
  margin-right: 20px;
}
.default-signature-1 {
  margin-left: 10px;
  margin-right: 20px;
  margin-top: 0px;
}
.default-select-button {
  margin-left: 10px;
  padding: 2px 5px;
}
.default-signature-preview {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-top: 5px;
  margin-left: 10px;
  min-height: 200px;
  margin-bottom: 10px;
}
input[type='file'] {
  height: 185px;
  width: 200px;
  opacity: 0;
}
.signature-border {
  border: 1px solid black;
}
.signature-preview {
  width: 200px;
}
.signature-upload {
  border: 1px solid black;
}
.upload-desc {
  text-align: center;
}
.success-changed {
  color: green;
}
.error-changed {
  color: red;
}
</style>
